import { inject, observer } from 'mobx-react';
import React, { Component, Fragment } from 'react';
import ReactResizeDetector from 'react-resize-detector';
import RevealBtn from './revealBtn';
import Icon from './icon';
import Error from './error';

@inject('igStore')
@observer
class Events extends Component {
  state = {
    height: 0,
    width: 0,
  };

  render() {
    const { events, game, reveal, error } = this.props.igStore;
    const { height } = this.state;
    const hasTime = events.find(e => e.time);
    const { sid } = game;

    if (error) return <Error />;
    if (!events.length) return null;
    return (
      <Fragment>
        <div className={`ig-item-wrapper${reveal ? ' ig-item-wrapper--open' : ''}`}>
          <div className="ig-log">
            {events.map(evt =>
              evt.type === 1 ? <Head {...evt} /> : <Body {...evt} sid={sid} hasTime={hasTime} />,
            )}
            <ReactResizeDetector
              handleHeight
              handleWidth
              onResize={(width, height) => this.setState({ width, height })}
            />
          </div>
        </div>
        <RevealBtn height={height} />
      </Fragment>
    );
  }
}

function Head({ text, score, time }) {
  return (
    <div className="ig-log__head">
      <div className="ig-log-score">{/*{score ? `${score.t1}` : ''}*/}</div>
      <div className="ig-log-event">{`${text}${time ? ` ${time}` : ''}`}</div>
      <div className="ig-log-score">{/*{score ? `${score.t2}` : ''}*/}</div>
    </div>
  );
}

function Body({ team, text, score, sid, type, time, hasTime }) {
  const event = (
    <Fragment>
      <Icon id={type} sid={sid} />
      <span>
        {text}
        {score ? <span style={{ fontWeight: 'normal' }}>{` ${score.t1}:${score.t2}`}</span> : ''}
      </span>
    </Fragment>
  );
  return (
    <div className="ig-log__body">
      <div className={`ig-log-event ig-log-event--type-${type}`}>{team === 1 ? event : null}</div>
      <div className={`ig-log-time${!hasTime ? ' ig-log-time--squashed' : ''}`}>{time}</div>
      <div className={`ig-log-event ig-log-event--type-${type}`}>{team === 2 ? event : null}</div>
    </div>
  );
}

export default Events;



// WEBPACK FOOTER //
// ./src/components/ig/events.js